exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".native.embedded-video{width:100%;height:100%}", "", {"version":3,"sources":["/build/src/code.justin.tv/web/wall/src/components/native-player/style.css"],"names":[],"mappings":"AAAA,uBACE,WAAY,AACZ,WAAa,CACd","file":"style.css","sourcesContent":[".native.embedded-video {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./src/components/native-player/style.css
// module id = 45
// module chunks = 0